import { cme_kurs } from './Kurs'
import { videoProgressSteps } from './GoogleAnalytics';


class Video {
    //#region PUBLIC METHODS

    // -- init video (some properties might be undefined depending on course-type)
    init(video = undefined, slides = undefined, starttime = undefined) {
        try {
            // set overlay
            this.#overlay = document.querySelector(".presentation-overlay");

            // main presentation-slide ( on left side => video- or image-chart)
            this.slideImage = document.querySelector("#slide");
            this.slideVideo = document.querySelector("#video-slide");

            // all thumbnails on right side
            this.allThumbnails = document.querySelectorAll('.single-thumbnail');

            // if video is available
            if (video && (starttime || starttime === 0)) {

                // set this video and start-time
                this.video = video;
                this.video.currentTime = starttime;

                // currentTime of video
                this.videoTimeSpan = document.querySelector(".currentVideoTime");
                // bar displays past time - width depending on video-progress
                this.timeBar = document.querySelector(".video-past-time-bar")
                // video-slider
                this.slider = document.querySelector(".video-slider");

                // display video-duration in video-bar
                var videoDurationDiv = document.querySelector(".videoDuration");
                videoDurationDiv.innerHTML = this.#formatVideoTime(this.video.duration);

                // set last slidetime
                if (!cme_kurs.isBigVideo && slides) {
                    slides[slides.length - 1].endtime = this.video.duration + 1; // +1 -> buffer if video ended
                }
            }

            console.log('%cVideo erfolgreich geladen', 'color: #00ff00');
        }
        catch (e) {
            console.log('%cVideo-Initialisierung fehlgeschlagen', 'color: #ff0000', e);
        }
    }

    // -- video on time-update
    videoTimeUpdate(slides, currentVideoTime, setCurrentVideoTime, videoProgress, setVideoProgress) {

        // catch error this.video not defined -> so localstorage can set videoTime-State first
        try {
            const currentTime = this.video.currentTime;

            // set slide status
            if (!cme_kurs.isBigVideo) {
                slides.forEach((singleSlide, index) => {

                    //active slide
                    if (currentTime >= singleSlide.starttime && currentTime < singleSlide.endtime) {

                        // slide changed if status is not active
                        if (singleSlide.status != "active") {
                            singleSlide.status = "active";

                            // onslide change gets triggered
                            this.onSlideChange(singleSlide);
                        }
                    }
                    // past slide
                    else if (currentTime >= singleSlide.endtime) {
                        singleSlide.status = "past";
                    }
                    // upcoming slide
                    else {
                        singleSlide.status = "upcoming";
                    }
                });
            }
            // change video-time-state every 5 seconds
            const timeDifference = currentTime - currentVideoTime;
            if (timeDifference < -5 || timeDifference > 5) {
                setCurrentVideoTime(currentTime);
            }

            // update current videotime
            this.videoTimeSpan.innerHTML = `<b>${this.#formatVideoTime(currentTime)}</b>`;

            // update visualization timebar
            this.timeBar.style.width = (this.video.currentTime / this.video.duration) * 100 + "%";

            // update slider
            this.slider.value = (this.video.currentTime / this.video.duration) * 100;


            // -- check video-progress and update state every 25% and send to google-analytics
            const videoDuration = this.video.duration;
            const progress = parseInt((currentTime / videoDuration) * 100);

            for (let i = 0; i < videoProgressSteps.length; i++) {
                const step = videoProgressSteps[i];
                const nextStep = videoProgressSteps[i + 1];

                if (nextStep === 100 && progress >= step && progress < nextStep && videoProgress !== step) setVideoProgress(100);
                else if (nextStep && progress >= step && progress < nextStep && videoProgress !== step) setVideoProgress(step);
            }
        }
        catch (e) {
            console.error("Video Meta-Data not loaded yet");
        }
    }

    // -- when video ends set play button
    countdownInterval;// countdown-interval for next course-part
    videoEnded(nextCoursePart, jumpToNextCoursePart) {
        this.togglePlayPauseIcon();

        // activate overlay
        if (!this.#overlay.classList.contains("overlay-active")) {
            this.#overlay.classList.add("overlay-active");
        }

        var partsCounter = cme_kurs.partsAmount;

        // -- go to next part
        if ((nextCoursePart) < partsCounter) {
            // toggle go to next part-btn and play-pause-container
            document.querySelector(".nextpart-btn-overlay").removeAttribute("hidden");

            // countdown to next part
            var countdownDiv = document.querySelector('.next-part-countdown');

            var counter = 0;
            var timer = 7;

            // start interval
            this.countdownInterval = setInterval(() => {
                // display time in countdowndiv within button
                countdownDiv.innerHTML = 7 - (++counter);

                // countdown bar displays progress
                document.querySelector('.countdown-bar').style = `width: 100%; transition: all ${timer - 1}s linear`;

                // when interval is finished
                if (counter >= timer) {
                    jumpToNextCoursePart();
                    clearInterval(this.countdownInterval);
                    // set timeout so nothing happens simultaneously
                    setTimeout(() => {
                        this.video.play();
                        this.togglePlayPauseIcon();
                    }, 500)
                }
            }, 1000);
        }
    }


    // -- on slide changed
    onSlideChange(targetSlide) {

        // -- set current slide if course-type is STANDARD
        if (!cme_kurs.isBigVideo && !cme_kurs.isPdf) {

            // determine slide type
            const arr = targetSlide.source.split('.');
            const slideType = arr[arr.length - 1];

            // always pause video chart
            this.slideVideo.pause();
            this.slideVideo.currentTime = 0;

            if (slideType == "mp4") {
                // -- this chart is a video

                // hide overlay
                this.#overlay.classList.remove("overlay-active");

                // hide standard image-slide and play video-chart
                this.slideImage.setAttribute("hidden", "");
                this.slideVideo.removeAttribute("hidden");
                this.slideVideo.src = targetSlide.source;
                this.slideVideo.play();

                // get and pause main video
                if (!cme_kurs.isPowerPoint) {
                    mainVideo.video.currentTime = targetSlide.starttime;
                    if (!mainVideo.video.paused) {
                        mainVideo.video.pause();
                        mainVideo.togglePlayPauseIcon();
                    }
                }

                // when video-slide is finished continue with main-video
                this.slideVideo.onended = () => {
                    this.slideVideo.pause();
                    if (!cme_kurs.isPowerPoint) mainVideo.video.click();
                }
            }
            else {
                // -- standard image chart
                this.slideVideo.setAttribute("hidden", "");
                this.slideImage.removeAttribute("hidden");
                this.slideImage.src = targetSlide.source;
            }

            // display current slides number in videocontrols ( x von xx )
            const active_chart_nr = document.querySelector(".chart_nr_active");
            active_chart_nr.innerHTML = targetSlide.chartNr;


            // -- set active thumbnail
            const activeIndex = targetSlide.chartNr - 1;

            this.allThumbnails.forEach((thumbnail, index) => {
                // -- past thumbnails
                if (index < activeIndex) {
                    thumbnail.setAttribute('status', 'past');
                }

                // -- active thumbnail
                else if (index === activeIndex) {
                    thumbnail.setAttribute('status', 'active');
                    // update active thumbnail -> wait for status to be set ( gets set in mainVideo.videoTimeUpdate )
                    setTimeout(() => {
                        if (thumbnail != null) {
                            // only scroll into view if right panel is visible
                            if (document.querySelector('#main-container').getAttribute('fullwidth') === "false") {
                                // scroll to active slide
                                thumbnail.scrollIntoView();
                            }
                        }
                    }, 100);
                }
                // -- upcoming thumbnails
                else {
                    thumbnail.setAttribute('status', 'upcoming');
                }
            });
        }
    }


    // -- bugfixing function for ios <= 14
    videoLoadBugfix(time) {

        if (this.video) {
            console.log("fix bug on ios <= 14");
            this.video.load();
            // load() resets videotime -> set it back here
            this.video.currentTime = time;
        }
    }


    // -- toggle play pause
    togglePlayPause(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        if (this.video.paused) {
            this.video.play();
            this.togglePlayPauseIcon();
        }
        else {
            this.video.pause();
            this.togglePlayPauseIcon();
        }
    }
    // -- toggle play/pause icon
    togglePlayPauseIcon() {
        var iconBox = document.querySelector(".play-pause-icon-box");
        if (this.video.paused) {
            // video is paused
            iconBox.classList.add("playicon");
            iconBox.classList.remove("pauseicon");
        }
        else {
            // video is playing
            iconBox.classList.remove("playicon");
            iconBox.classList.add("pauseicon");
        }
    }


    // -- 10 seconds jump
    plus10secs(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        this.video.currentTime += 10;
    }
    minus10secs(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        this.video.currentTime -= 10;
    }

    // -- go to next chart
    gotoNextChart(e, slides, courseIndex = null) {
        e.stopPropagation();
        this.#goToChart((this.#getActiveChartNr(slides) + 1), slides, courseIndex);
    }
    // -- go to prev chart
    gotoPrevChart(e, slides, courseIndex = null) {
        e.stopPropagation();
        this.#goToChart((this.#getActiveChartNr(slides) - 1), slides, courseIndex);
    }

    // -- go to video position when clicking on slider
    seekVideoPos(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        var thisSlider = e.currentTarget;

        var seekedTime = this.video.duration * (thisSlider.value / 100);
        this.video.currentTime = seekedTime;
    }


    // -- manage audio input
    changeVolume(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        var volume = e.currentTarget.value / 100;
        var volumeIcon = e.currentTarget.parentNode;

        this.video.volume = volume;

        if (volume === 0) {
            volumeIcon.classList.remove('vc_icon_volume-max');
            volumeIcon.classList.remove('vc_icon_volume-mid');
            volumeIcon.classList.add('vc_icon_volume-min');
        }
        else if (volume > 0 && volume < 0.7) {
            volumeIcon.classList.remove('vc_icon_volume-max');
            volumeIcon.classList.remove('vc_icon_volume-min');
            volumeIcon.classList.add('vc_icon_volume-mid');
        }
        else {
            volumeIcon.classList.remove('vc_icon_volume-max');
            volumeIcon.classList.remove('vc_icon_volume-mid');
            volumeIcon.classList.add('vc_icon_volume-max');
        }
    }


    // -- toggle overlay
    toggleOverlay() {
        this.#overlay.classList.toggle("overlay-active");
        this.#startOverlayTimer();
    }


    // -- fullscreen mode
    toggleFullScreen(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        document.body.toggleAttribute('isFullscreen');

        // toggle fullscreen icon
        e.currentTarget.classList.toggle('vc_icon_fullscreen');
        e.currentTarget.classList.toggle('vc_icon_fullscreen_exit');

        this.#toggleRealFullscreen(document.body);
    }

    // -- presentation mode
    togglePresentationMode(e) {
        e.stopPropagation();
        this.#startOverlayTimer();

        document.body.toggleAttribute('isPresentationMode');

        // toggle presentationmode icon
        e.currentTarget.classList.toggle('vc_icon_presentation');
        e.currentTarget.classList.toggle('vc_icon_presentation_exit');

        this.#toggleRealFullscreen(document.body);
    }

    // -- set default screen
    setDefaultScreen() {
        this.#startOverlayTimer();

        // hide go to next course-part button
        if (document.querySelector(".nextpart-btn-overlay")) { document.querySelector(".nextpart-btn-overlay").setAttribute("hidden", "") };


        // -- fire click events for toggling different presentation screens

        // slidescontainer
        if (document.querySelector('.resize-shrink-grey')) {
            document.querySelector('.resize-shrink-grey').click();
        }
        // right panel
        if (document.querySelector('#main-container').getAttribute("fullwidth") == "true" && !cme_kurs.isBigVideo && !cme_kurs.isPdf) {
            document.querySelector('.video_header').click();
        }
        // presentation mode
        if (document.body.hasAttribute("isPresentationMode") && !cme_kurs.isBigVideo && !cme_kurs.isPdf) {
            document.querySelector('.vc_icon_presentation_exit').click();
        }
        // fullscreen
        if (document.body.hasAttribute("isFullscreen")) {
            document.querySelector('.vc_icon_fullscreen_exit').click();
        }
    }

    //#endregion



    //#region PRIVATE PROPERTIES & METHODS

    #overlay; #overlayTimeout;

    // hide overlay with video controls after defined seconds    
    #startOverlayTimer() {
        var timer = 4;
        // GlobalVar timeout
        clearTimeout(this.#overlayTimeout);
        this.#overlayTimeout = setTimeout(() => {

            if (!cme_kurs.isPowerPoint) {
                // only hide overlay after {timer} seconds when playing
                if (!mainVideo.video.paused) {
                    this.#overlay.classList.remove("overlay-active");
                }
            }
            else {
                this.#overlay.classList.remove("overlay-active");
            }
        }, timer * 1000);
    }


    // go to specific chart
    #goToChart(targetChart, slides, courseIndex) {
        this.#startOverlayTimer();
        var targetChartTime;

        if (!cme_kurs.isPowerPoint) {

            // -- Standard Kurstyp
            // if next chart exists
            if (targetChart > 0 && targetChart < slides.length) {
                targetChartTime = slides[targetChart].starttime;
                mainVideo.video.currentTime = targetChartTime;
            }
            // beginning of video
            else if (targetChart <= 0) {
                mainVideo.video.currentTime = 0;
            }
            // end of video
            else if (targetChart >= slides.length) {
                mainVideo.video.currentTime = mainVideo.video.duration;
            }
        }
        else {

            // -- PowerPoint Kurstyp
            // if next chart exists
            if (targetChart >= 0 && targetChart < slides.length) {
                this.onSlideChange(slides[targetChart]);
            }
            // last slide
            else if (targetChart >= slides.length) {
                this.onSlideChange(slides[slides.length - 1]);
            }
        }
    }

    // get active chartNr
    #getActiveChartNr() {
        var activeChartNr;
        this.allThumbnails.forEach((singleThumbnail, index) => {
            if (singleThumbnail.getAttribute('status') === "active") {
                activeChartNr = index;
            }
        })
        return activeChartNr;
    }

    // -- toggle fullscreen / presentation mode
    #toggleRealFullscreen(elem) {

        document.body.toggleAttribute('isRealFullscreen');

        if (document.body.hasAttribute('isRealFullscreen')) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }
        }
    }

    // -- format video-time
    #formatVideoTime(sec) {
        var date = new Date(null);
        date.setSeconds(sec);

        if (mainVideo && ((mainVideo.video.duration / 60 / 60) > 1)) {
            // video longer than 1 hour
            return date.toISOString().substr(12, 7);
        }
        else {
            // video shorter than 1 hour
            return date.toISOString().substr(14, 5);
        }
    }

    //#endregion
}



// -- main video
const mainVideo = new Video();


export { mainVideo }